module.exports = __webpack_public_path__ + "img/product-icon_4.c77806d0.png";